export default __webpack_public_path__ + "e704efc418a47bf21c56e30c34c2a337.svg";